import React from 'react';
const links = ['Conditions Générales', 'Politique de Confidentialité', 'Politique de Remboursement', 'Contact'];
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-92" data-mp="3gh3rcermy6f5">
      <div className="mx-auto max-w-5xl text-center" data-id="element-93" data-mp="32ovvqqc38li1">
        <p className="font-display text-xl font-black uppercase tracking-tight text-ink" data-id="element-94" data-mp="36pfsvtwnvp46">
          ANGLAIS PRÊT™
        </p>
        <nav aria-label="Pied de page" data-id="element-95" data-mp="3uesbfkdvp9j5">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-ink/55" data-id="element-96" data-mp="3uftmhouw9w0v">
            {links.map(link => <li key={link} data-id="element-97" data-mp="3lf57orxofrmx">
                <a href="#offer" className="transition-colors duration-150 ease-out hover:text-brand" data-id="element-98" data-mp="3ldu874b9l61m">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-ink/40" data-id="element-99" data-mp="2eyt9iquuu9rc">
          © 2026 ANGLAIS PRÊT™. Tous droits réservés.
        </p>
      </div>
    </footer>;
}